import { Action } from 'redux';
import {
  IAPIServiceConfigItem,
  IAPIServicesApproveItem,
  IMyFavoriteItem,
} from '../../../model/api-modules';
import {
  IAPIGameItem,
  IFavoriteTotalItem,
} from '../../../model/api-modules/game';
import {
  IGameEnvModel,
  IApiGameEnvCollectionRes,
} from '../../../model/api-modules/env';

export enum ReduxGamesActionType {
  GET_GAMES = 'GET_GAMES',
  SELECT_GAME = 'SELECT_GAME',
  ALL_MENU_CONFIG = 'ALL_MENU_CONFIG',
  OPEN_MENU_STATUS = 'OPEN_MENU_STATUS',
  SET_ALL_ENVS = 'SET_ALL_ENVS',
  SELECT_ENV = 'SELECT_ENV',
  SELECT_MENU_ID = 'SELECT_MENU_ID',
  MY_FAVORITE = 'MY_FAVORITE',
  ALL_ENV_LIST = 'ALL_ENV_LIST',
}

export interface ISelectMenuIdAction extends Action {
  type: ReduxGamesActionType.SELECT_MENU_ID;
  result: number;
}

export interface IMyFavoriteAction extends Action {
  readonly type: 'MyFavorite';
  readonly result: ReadonlyArray<IMyFavoriteItem>;
}

export interface IServiceFavoriteTotalAction extends Action {
  readonly type: 'ServiceFavoriteTotal';
  readonly result: ReadonlyArray<IFavoriteTotalItem>;
}

export interface IAllEnvListAction extends Action {
  type: ReduxGamesActionType.ALL_ENV_LIST;
  result: IApiGameEnvCollectionRes[];
}

export interface IGetGamesAction extends Action {
  type: ReduxGamesActionType.GET_GAMES;
  result: IAPIGameItem[];
}
export interface ISelectGameAction extends Action {
  type: ReduxGamesActionType.SELECT_GAME;
  result: IAPIGameItem | string;
}

export interface IAllMenuConfigAction extends Action {
  type: ReduxGamesActionType.ALL_MENU_CONFIG;
  result: IAPIServiceConfigItem[];
}

export interface IOpenMenuStatusAction extends Action {
  type: ReduxGamesActionType.OPEN_MENU_STATUS;
  result: IAPIServicesApproveItem[];
}

export interface ISetAllEnvsAction extends Action {
  type: ReduxGamesActionType.SET_ALL_ENVS;
  result: IGameEnvModel[];
}

export interface ISelectEnvAction extends Action {
  type: ReduxGamesActionType.SELECT_ENV;
  result: IGameEnvModel | null;
}

export type GamesAction =
  | IGetGamesAction
  | ISelectGameAction
  | IAllMenuConfigAction
  | IOpenMenuStatusAction
  | ISetAllEnvsAction
  | ISelectEnvAction
  | ISelectMenuIdAction
  | IMyFavoriteAction
  | IServiceFavoriteTotalAction
  | IAllEnvListAction;

export interface IGamesState {
  readonly games: IAPIGameItem[];
  readonly selectGame: IAPIGameItem | null;
  readonly allServiceConfig: IAPIServiceConfigItem[] | null;
  readonly openMenuStatus: IAPIServicesApproveItem[] | null;
  readonly envs: ReadonlyArray<IGameEnvModel>;
  readonly selectEnv: IGameEnvModel | null;

  readonly selectMenuId: number;
  readonly myFavoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly serviceFavoriteTotal: ReadonlyArray<IFavoriteTotalItem>;
  readonly allEnvList: IApiGameEnvCollectionRes[];
}
